import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import xss from 'xss'

import Badge, { BADGE_COLORS, BADGE_SIZES } from "@components/Badge/Badge"

import {
  IntegrationsFeaturedAppsDIV,
  IntegrationsFeaturedAppsCardLINK,
} from './IntegrationsFeaturedApps.styles'
import { graphql, useStaticQuery } from 'gatsby'
import { IntegrationsFeaturedAppsQueryQuery } from '@graphqlTypes'
import LpSection from '@components/lp/LpSection/LpSection'
import TextLink from '@components/TextLink/TextLink'

const IntegrationsFeaturedApps = () => {
  const { featuredIntegrationsData: { nodes: integrations } } = useStaticQuery<IntegrationsFeaturedAppsQueryQuery>(graphql`
    query IntegrationsFeaturedAppsQuery {
      featuredIntegrationsData: allContentfulIntegration(
        limit: 4
        filter: {
          isFeatured: {eq: true}
        }
        sort: {title: ASC}
      ) {
        nodes {
          featuredDescription
          featuredLogo {
            imgixImage {
              gatsbyImageData(width: 148)
              url
            }
          }
          link
          isPlus
          slug
          title
        }
      }
    }
  `)

  return (
    <LpSection
      className="IntegrationsFeaturedApps"
      uniqueId="IntegrationsFeaturedApps"
    >
      <div className="container">
        <IntegrationsFeaturedAppsDIV className={`item-count--${integrations.length}`}>
          {integrations.map((integration) => (
            <IntegrationsFeaturedAppsCardLINK
              as={!integration.link ? undefined : 'a'}
              href={!integration.link ? undefined : integration.link}
              key={integration.title}
              to={!integration.link ? `/help-desk-integration/${integration.slug}` : undefined}
            >
              {integration.isPlus &&
                <Badge
                  className="Badge"
                  color={BADGE_COLORS.PURPLE}
                  size={BADGE_SIZES.XS}
                >Plus</Badge>}
              {integration.featuredLogo?.imgixImage &&
                integration.featuredLogo.imgixImage.gatsbyImageData ? (
                <GatsbyImage
                  alt={integration.title || "Integration App Logo"}
                  image={integration.featuredLogo?.imgixImage?.gatsbyImageData}
                  style={{ width: '100%', maxWidth: '180px' }}
                />
              ) : (
                <img
                  alt={integration.title || "Integration App Logo"}
                  src={integration.featuredLogo?.imgixImage?.url || ""}
                  style={{ width: '100%', maxWidth: '180px' }}
                />
              )
              }
              {integration.featuredDescription && (
                <p dangerouslySetInnerHTML={{ __html: xss(integration.featuredDescription) }} />
              )}
              <div className="learn-more">
                <TextLink>Learn more</TextLink>
              </div>
            </IntegrationsFeaturedAppsCardLINK>
          ))}
        </IntegrationsFeaturedAppsDIV>
      </div>
    </LpSection>
  )
}

export default IntegrationsFeaturedApps
